import CategoryPopup from '../../../../Category/CategoryPopup';

const PreviewPopupTable = ({category,hidePopup}) => {

  return (
    <>
      <CategoryPopup
        onClose={hidePopup}
        useTableInAuditTrail={true}
        auditTrailRow={
          <tr>
            <td
              style={{
                width: "250px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                padding: "3px",
              }}
            >
              {category.field_name}
            </td>
            <td
              style={{
                width: "250px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                padding: "3px",
              }}
            >
              {category.category_name}
            </td>
            <td
              style={{
                width: "250px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                padding: "3px",
              }}
            >
              {category.description}
            </td>
          </tr>
        }
      />
    </>
  );}



export default PreviewPopupTable